export default "__VITE_ASSET__mgNScDhH__"